import clsx from 'clsx';

import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './workOrderElementView.module.css';

interface View {
  value: string;
  icon: string;
}

interface Props {
  view: View;
  activeView: View;
  setActiveView: (view: View) => void;
}

const ElementNavigationIcon = ({ view, activeView, setActiveView }: Props) => {
  const iconColor =
    activeView.value === view.value ? colors.brand.blue : colors.neutral.gray;

  return (
    <div
      onClick={() => setActiveView(view)}
      className={clsx(
        classes.iconContainer,
        activeView.value === view.value && classes.active,
      )}
    >
      <IconButton>
        <Icon color={iconColor}>{view.icon}</Icon>
      </IconButton>
    </div>
  );
};

export default ElementNavigationIcon;
